import { get_kmb_number } from "src/utils/constants";

export default function DashboradCountCard({ title, count, icon, bgColor }) {
  return (
    <div className="card dashborad-count-card">
      <div
        className="count-card-icon"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(${bgColor}, 0) 0%, rgba(${bgColor}, 0.24) 100%)`,
          color: "#f6bd4b",
        }}
      >
        {icon}
      </div>
      <h4 style={{ color: "#fff" }}>£{get_kmb_number(count)}</h4>
      <h6 style={{ color: "#fff" }}>{title}</h6>
    </div>
  );
}
